import { Component, OnInit, ViewChild } from '@angular/core';
import { Services1Service } from '../services/services1.service';
import { UnityLibreComponent } from '../unity_libre/unity_libre.component';

@Component({
  selector: 'app-laboratorio_libre',
  templateUrl: './laboratorio_libre.component.html',
  styleUrls: ['./laboratorio_libre.component.css']
})
export class LaboratorioLibreComponent implements OnInit {

  animationName = "Unknown";

  constructor() { }

  @ViewChild('unity_libre', { static: true }) unity_libre: UnityLibreComponent;

  ngOnInit() {

    (window as any).animationChangeListener = (animationName: string) => {
      this.animationName = animationName;
    }
    
  }

  setName(): void {
    this.unity_libre.setName();
  }

  get unityIsLoaded(): boolean {
    return this.unity_libre.progress === 1;
  }

  get progress(): number {
    return this.unity_libre.progress * 100;
  }
  

}
